module.exports = __webpack_public_path__ + "static/img/far1_active.66770b00.png";